module.exports = new __parcel__URL__("dog.6630bd37.svg").toString();